<kodit-dropdown
  [options]="items"
  [formCtrl]="tipCtrl"
  (optionChanged)="handleOnItemChange($event)"
>
</kodit-dropdown>
